import React from 'react';
import { Box, Container, List, ListItem, ListItemText, Paper, Stack, Typography, useTheme } from '@mui/material';
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import {Helmet} from "react-helmet";

const iconCss = {
  width: 64,
  height: 64,
  borderRadius: 3,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}

const AboutPage: React.FC = () => {

  const theme = useTheme();

  const services = [
    'Conducting forward e-auctions',
    'Mobile application for bidding',
    'Steel information and rates of steel scrap via sms, mail',
    'Market analysis reports',
    'All documents submission process available on our website',
    'Online and offline support from Scrap e-Auction dedicated team'
  ];

  const benefits = [
    "Simple and transparent scrap e-auction",
    "Cost-effective selling compared to traditional methods",
    "Conclusive deals in a few hours without physical presence",
    "Privacy during entire e-process",
    "Comfort of conducting sell or buy from any location",
    "Reliable information on availability and quality of material",
    "Facility for company see online auction in company login",
    "Transparent pricing based on market situation",
    "Availability of value added services like inspection of material, scrap price, etc.",
    "Disposal of large/small quantity stock in shorter time period."
  ];

  return (
    <>
      <Helmet>
        <title>About Us - Scrap E-Auction Online Scrap Metal Auction Platform</title>
        <meta name="description" content="Learn about India's leading steel scrap e-auction platform" />
      </Helmet>
      <Box sx={{ backgroundColor: '#fbf9fa'}}>
        <Container sx={{ py: 4, bgcolor: '#fbf9fa' }}>
          <Stack gap={5} direction="column">
            <Box sx={{ mt: 4, textAlign: 'center' }}>
              <Typography variant="h1" gutterBottom sx={{ fontWeight: '600' }}>
                About Steel E-Auction
              </Typography>
              <Typography variant="body1" gutterBottom color="textSecondary">
                {`India's Premier Platform for Steel Scrap Trading`}
              </Typography>
            </Box>
            <Paper sx={{ p: 4 }}>
              <Typography variant="body1" component="p">
                <Typography component="span" color='primary'>Scrap e-Auction</Typography> is the simplified and transparent online scrap auction in industrial scrap management solution in India. With our scrap online auction process, scrap buyer whether small or large, are assured of the scrap online auction delivered to them in most simple, efficient and transparent manner anywhere in the country. We constantly strive to ensure that our buyer remain not more than a click away from fulfilling their steel requirements.
              </Typography>
            </Paper>
            <Paper sx={{ p: 4 }}>
              <Typography variant="h3" fontWeight={600} mb={2}>Our Services</Typography>
              <Typography variant="body1" component="p">
                <Typography component="span" color='primary'>Scrap e-Auction</Typography> has service offerings spanning the entire e-Commerce spectrum and operates through www.scrapauction.in. Scrap e-Auction aims to make steel buying a customer friendly activity with transparency in pricing and policies with our assurance of quality and quantity backed by reputed manufacturers with whom we have firm arrangements to retail their products. Our module is dynamic, user-friendly, transparent, and gives you a secured access.
              </Typography>
            </Paper>
            <Paper sx={{ p: 4 }}>
              <Typography variant="h3" fontWeight={600} mb={2}>We Offered Services</Typography>
              <List sx={{ listStyleType: "disc", pl: 4 }}>
                {services.map((item, index) => (
                  <ListItem key={index} sx={{ display: "list-item", py: 0.5 }}>
                    <ListItemText primary={item} />
                  </ListItem>
                ))}
              </List>
            </Paper>
            <Stack direction="row" gap={4} justifyContent="space-between">
              <Paper sx={{ p: 4 }}>
                <Stack direction="row" gap={3} alignItems="center" mb={2}>
                  <Box sx={{ ...iconCss, backgroundColor: "#dbeafe" }}>
                    <SecurityOutlinedIcon sx={{ fontSize: 32, color: "#2563eb" }} />
                  </Box>
                  <Typography variant="h5" sx={{ fontWeight: 700 }}>
                    Trust & Security
                  </Typography>
                </Stack>
                <Typography variant="body1">
                  All users undergo thorough verification by our admin team. We maintain strict standards to ensure that only genuine businesses participate on our platform.
                </Typography>
              </Paper>
              <Paper sx={{ p: 4 }}>
                <Stack direction="row" gap={3} alignItems="center" mb={2}>
                  <Box sx={{ ...iconCss, backgroundColor: "#dcfce7" }}>
                    <TrendingUpIcon sx={{ fontSize: 32, color: "#00a63e" }} />
                  </Box>
                  <Typography variant="h5" sx={{ fontWeight: 700 }}>
                  Transparency
                  </Typography>
                </Stack>
                <Typography variant="body1">
                  Our auction process is completely transparent. Real-time bidding, complete bid history, and clear pricing ensure fairness for all participants.
                </Typography>
              </Paper>
            </Stack>
            <Stack direction="row" gap={4} justifyContent="space-between">
              <Paper sx={{ p: 4 }}>
                <Stack direction="row" gap={3} alignItems="center" mb={2}>
                  <Box sx={{ ...iconCss, backgroundColor: "#f3e8ff" }}>
                    <Diversity2Icon sx={{ fontSize: 32, color: "#9810fa" }} />
                  </Box>
                  <Typography variant="h5" sx={{ fontWeight: 700 }}>
                    Nationwide Network
                  </Typography>
                </Stack>
                <Typography variant="body1">
                Connect with verified buyers and sellers from across India. Our platform brings together the entire steel scrap trading ecosystem in one place.
                </Typography>
              </Paper>
              <Paper sx={{ p: 4 }}>
                <Stack direction="row" gap={3} alignItems="center" mb={2}>
                  <Box sx={{ ...iconCss, backgroundColor: "#ffedd4" }}>
                    <WorkspacePremiumIcon sx={{ fontSize: 32, color: "#f54a00" }} />
                  </Box>
                  <Typography variant="h5" sx={{ fontWeight: 700 }}>
                    Excellence
                  </Typography>
                </Stack>
                <Typography variant="body1">
                  We are committed to providing the best user experience, continuous improvement, and exceptional customer support to all our users.
                </Typography>
              </Paper>
            </Stack>
            <Paper sx={{ p: 4 }}>
              <Typography variant="h3" fontWeight={600} mb={2}>How it will help you?</Typography>
              <List sx={{ listStyleType: "disc", pl: 4 }}>
                {benefits.map((item, index) => (
                  <ListItem key={index} sx={{ display: "list-item", py: 0.5 }}>
                    <ListItemText primary={item} />
                  </ListItem>
                ))}
              </List>
            </Paper>
            <Paper
              sx={{
                p: 4,
                backgroundColor: theme.palette.primary.main,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1
              }}
            >
              <Typography variant="h3" color="#ffffff" fontWeight={600} mb={2}>Ready to Get Started?</Typography>
              <Typography variant="body1" color="#ffffff">
                {`Join India's most trusted steel scrap e-auction platform today`}
              </Typography>
            </Paper>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default AboutPage;
